/** Black fill/stroke in Hand_tap.json (Lottie normalized RGBA). */
const HAND_TAP_BLACK_RGBA = [0, 0, 0, 1] as const
const HAND_TAP_WHITE_RGBA = [1, 1, 1, 1] as const

function isHandTapBlackRgba(value: unknown): value is readonly [0, 0, 0, 1] {
  return (
    Array.isArray(value) &&
    value.length === 4 &&
    value[0] === HAND_TAP_BLACK_RGBA[0] &&
    value[1] === HAND_TAP_BLACK_RGBA[1] &&
    value[2] === HAND_TAP_BLACK_RGBA[2] &&
    value[3] === HAND_TAP_BLACK_RGBA[3]
  )
}

function recolorBlackFillsAndStrokes(node: unknown): void {
  if (!node || typeof node !== 'object') return

  if (Array.isArray(node)) {
    node.forEach(recolorBlackFillsAndStrokes)
    return
  }

  const record = node as Record<string, unknown>
  const color = record.c
  if (color && typeof color === 'object' && isHandTapBlackRgba((color as { k?: unknown }).k)) {
    ;(color as { k: number[] }).k = [...HAND_TAP_WHITE_RGBA]
  }

  Object.values(record).forEach(recolorBlackFillsAndStrokes)
}

/** Returns a copy of the bundled Hand_tap Lottie with black fills/strokes recolored to white. */
export function recolorHandTapLottieToWhite(source: object): object {
  const clone = structuredClone(source)
  recolorBlackFillsAndStrokes(clone)
  return clone
}
